import { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { MeshBackground } from '../components/MeshBackground'
import { TopNav } from './TopNav'
import { SiteFooter } from '../components/SiteFooter'

// App/dashboard routes where footer is not shown
const APP_PATHS = ['/dashboard', '/wallet', '/settings', '/security', '/protection', '/chain']

interface AppShellProps {
  children: ReactNode
}

export function AppShell({ children }: AppShellProps) {
  const location = useLocation()
  const showFooter = !APP_PATHS.some(p => location.pathname.startsWith(p))

  return (
    <div className="min-h-screen font-body text-white">
      <MeshBackground />
      <TopNav />
      <main className="pt-16">
        {children}
      </main>
      {showFooter && <SiteFooter />}
    </div>
  )
}
